import React, { createContext, useContext, useState, useEffect } from 'react';

const STORAGE_KEY = 'nexsap_lang';

export const LANGUAGES = [
  { code: 'fr', label: 'Français',  flag: '🇫🇷', dir: 'ltr' },
  { code: 'en', label: 'English',   flag: '🇬🇧', dir: 'ltr' },
  { code: 'ar', label: 'العربية',   flag: '🇸🇦', dir: 'rtl' },
  { code: 'es', label: 'Español',   flag: '🇪🇸', dir: 'ltr' },
];

const T = {
  fr: {
    // nav
    home: 'Accueil', explore: 'Explorer', messages: 'Messages',
    videos: 'Vidéos', create: 'Créer', profile: 'Profil', settings: 'Paramètres',
    notifications: 'Notifs',
    // explore
    exploreTitle: 'Explorez Nexsap', exploreSubtitle: 'Choisissez une catégorie.',
    searchPlaceholder: 'Produit, marque…', forYou: '✦ Pour toi',
    basedOnTaste: 'Basé sur tes goûts', discover: 'Découvrir',
    topCategories: 'Tes catégories préférées', allCategories: 'Toutes les catégories',
    categories: 'Catégories', noResult: 'Aucun résultat', reset: 'Réinitialiser',
    results: 'résultat', results_plural: 'résultats',
    sortBy: 'Trier par', smart: '✦ Pour toi', popular: 'Populaires',
    priceAsc: 'Prix ↑', priceDesc: 'Prix ↓',
    // category page
    noProducts: 'Aucun produit dans cette catégorie.', end: '— Fin —',
    product: 'produit', products: 'produits',
    // accueil
    search: 'Rechercher…',
    // creer
    newProduct: 'Nouveau produit', titleLabel: 'Titre *', titlePlaceholder: 'Ex: Nike Air Max 90…',
    priceLabel: 'Prix (USD)', categoryLabel: 'Catégorie *', chooseCategory: 'Choisir une catégorie…',
    descLabel: 'Description', descPlaceholder: 'Décrivez votre produit…',
    addPhoto: 'Ajouter une photo', photoSub: 'JPG, PNG · max 5 Mo',
    publish: 'Publier', publishing: 'Publication…', published: 'Produit publié !',
    publishedSub: 'Votre produit est maintenant visible.', publishAnother: 'Publier un autre',
    loginToPublish: 'Connectez-vous pour publier', loginSub: 'Partagez vos produits avec la communauté Nexsap.',
    login: 'Se connecter', titleRequired: 'Le titre est requis.', chooseRequired: 'Choisissez une catégorie.',
    error: 'Une erreur est survenue. Réessayez.',
    // settings
    settingsTitle: 'Paramètres', language: 'Langue', languageSub: 'Choisir la langue de l\'application',
    appearance: 'Apparence', theme: 'Thème', themeLight: 'Clair', themeDark: 'Sombre', themeAuto: 'Auto',
    account: 'Compte', logout: 'Se déconnecter', version: 'Version',
    detected: 'Langue détectée automatiquement',
    // categories
    vetements: 'Vêtements', chaussures: 'Chaussures', electronique: 'Électronique',
    jeuxVideo: 'Jeux vidéo', laptops: 'Laptops', cameras: 'Caméras', maison: 'Maison', autre: 'Autre',
  },
  en: {
    home: 'Home', explore: 'Explore', messages: 'Messages',
    videos: 'Videos', create: 'Create', profile: 'Profile', settings: 'Settings',
    notifications: 'Notifs',
    exploreTitle: 'Explore Nexsap', exploreSubtitle: 'Choose a category to start.',
    searchPlaceholder: 'Product, brand…', forYou: '✦ For you',
    basedOnTaste: 'Based on your taste', discover: 'Discover',
    topCategories: 'Your favorite categories', allCategories: 'All categories',
    categories: 'Categories', noResult: 'No results', reset: 'Reset',
    results: 'result', results_plural: 'results',
    sortBy: 'Sort by', smart: '✦ For you', popular: 'Popular',
    priceAsc: 'Price ↑', priceDesc: 'Price ↓',
    noProducts: 'No products in this category.', end: '— End —',
    product: 'product', products: 'products',
    search: 'Search…',
    newProduct: 'New product', titleLabel: 'Title *', titlePlaceholder: 'e.g. Nike Air Max 90…',
    priceLabel: 'Price (USD)', categoryLabel: 'Category *', chooseCategory: 'Choose a category…',
    descLabel: 'Description', descPlaceholder: 'Describe your product…',
    addPhoto: 'Add a photo', photoSub: 'JPG, PNG · max 5 MB',
    publish: 'Publish', publishing: 'Publishing…', published: 'Product published!',
    publishedSub: 'Your product is now visible.', publishAnother: 'Publish another',
    loginToPublish: 'Log in to publish', loginSub: 'Share your products with the Nexsap community.',
    login: 'Log in', titleRequired: 'Title is required.', chooseRequired: 'Please choose a category.',
    error: 'An error occurred. Please try again.',
    settingsTitle: 'Settings', language: 'Language', languageSub: 'Choose the app language',
    appearance: 'Appearance', theme: 'Theme', themeLight: 'Light', themeDark: 'Dark', themeAuto: 'Auto',
    account: 'Account', logout: 'Log out', version: 'Version',
    detected: 'Language detected automatically',
    vetements: 'Clothing', chaussures: 'Shoes', electronique: 'Electronics',
    jeuxVideo: 'Video Games', laptops: 'Laptops', cameras: 'Cameras', maison: 'Home', autre: 'Other',
  },
  ar: {
    home: 'الرئيسية', explore: 'استكشاف', messages: 'الرسائل',
    videos: 'فيديوهات', create: 'إنشاء', profile: 'الملف', settings: 'الإعدادات',
    notifications: 'إشعارات',
    exploreTitle: 'استكشف Nexsap', exploreSubtitle: 'اختر فئة للبدء.',
    searchPlaceholder: 'منتج، علامة تجارية…', forYou: '✦ لك',
    basedOnTaste: 'بناءً على اهتماماتك', discover: 'اكتشف',
    topCategories: 'فئاتك المفضلة', allCategories: 'جميع الفئات',
    categories: 'الفئات', noResult: 'لا نتائج', reset: 'إعادة تعيين',
    results: 'نتيجة', results_plural: 'نتائج',
    sortBy: 'ترتيب حسب', smart: '✦ لك', popular: 'الأكثر شعبية',
    priceAsc: 'السعر ↑', priceDesc: 'السعر ↓',
    noProducts: 'لا توجد منتجات في هذه الفئة.', end: '— النهاية —',
    product: 'منتج', products: 'منتجات',
    search: 'بحث…',
    newProduct: 'منتج جديد', titleLabel: 'العنوان *', titlePlaceholder: 'مثال: Nike Air Max 90…',
    priceLabel: 'السعر (USD)', categoryLabel: 'الفئة *', chooseCategory: 'اختر فئة…',
    descLabel: 'الوصف', descPlaceholder: 'صف منتجك…',
    addPhoto: 'إضافة صورة', photoSub: 'JPG, PNG · حد أقصى 5 MB',
    publish: 'نشر', publishing: 'جارٍ النشر…', published: 'تم نشر المنتج!',
    publishedSub: 'منتجك مرئي الآن.', publishAnother: 'نشر منتج آخر',
    loginToPublish: 'سجّل دخولك للنشر', loginSub: 'شارك منتجاتك مع مجتمع Nexsap.',
    login: 'تسجيل الدخول', titleRequired: 'العنوان مطلوب.', chooseRequired: 'اختر فئة.',
    error: 'حدث خطأ. حاول مرة أخرى.',
    settingsTitle: 'الإعدادات', language: 'اللغة', languageSub: 'اختر لغة التطبيق',
    appearance: 'المظهر', theme: 'السمة', themeLight: 'فاتح', themeDark: 'داكن', themeAuto: 'تلقائي',
    account: 'الحساب', logout: 'تسجيل الخروج', version: 'الإصدار',
    detected: 'تم اكتشاف اللغة تلقائياً',
    vetements: 'ملابس', chaussures: 'أحذية', electronique: 'إلكترونيات',
    jeuxVideo: 'ألعاب فيديو', laptops: 'لابتوبات', cameras: 'كاميرات', maison: 'المنزل', autre: 'أخرى',
  },
  es: {
    home: 'Inicio', explore: 'Explorar', messages: 'Mensajes',
    videos: 'Videos', create: 'Crear', profile: 'Perfil', settings: 'Ajustes',
    notifications: 'Notifs',
    exploreTitle: 'Explora Nexsap', exploreSubtitle: 'Elige una categoría para empezar.',
    searchPlaceholder: 'Producto, marca…', forYou: '✦ Para ti',
    basedOnTaste: 'Basado en tus gustos', discover: 'Descubrir',
    topCategories: 'Tus categorías favoritas', allCategories: 'Todas las categorías',
    categories: 'Categorías', noResult: 'Sin resultados', reset: 'Restablecer',
    results: 'resultado', results_plural: 'resultados',
    sortBy: 'Ordenar por', smart: '✦ Para ti', popular: 'Populares',
    priceAsc: 'Precio ↑', priceDesc: 'Precio ↓',
    noProducts: 'No hay productos en esta categoría.', end: '— Fin —',
    product: 'producto', products: 'productos',
    search: 'Buscar…',
    newProduct: 'Nuevo producto', titleLabel: 'Título *', titlePlaceholder: 'Ej: Nike Air Max 90…',
    priceLabel: 'Precio (USD)', categoryLabel: 'Categoría *', chooseCategory: 'Elegir categoría…',
    descLabel: 'Descripción', descPlaceholder: 'Describe tu producto…',
    addPhoto: 'Agregar foto', photoSub: 'JPG, PNG · máx 5 MB',
    publish: 'Publicar', publishing: 'Publicando…', published: '¡Producto publicado!',
    publishedSub: 'Tu producto ya está visible.', publishAnother: 'Publicar otro',
    loginToPublish: 'Inicia sesión para publicar', loginSub: 'Comparte tus productos con la comunidad Nexsap.',
    login: 'Iniciar sesión', titleRequired: 'El título es obligatorio.', chooseRequired: 'Elige una categoría.',
    error: 'Ocurrió un error. Inténtalo de nuevo.',
    settingsTitle: 'Ajustes', language: 'Idioma', languageSub: 'Elegir el idioma de la aplicación',
    appearance: 'Apariencia', theme: 'Tema', themeLight: 'Claro', themeDark: 'Oscuro', themeAuto: 'Auto',
    account: 'Cuenta', logout: 'Cerrar sesión', version: 'Versión',
    detected: 'Idioma detectado automáticamente',
    vetements: 'Ropa', chaussures: 'Zapatos', electronique: 'Electrónica',
    jeuxVideo: 'Videojuegos', laptops: 'Laptops', cameras: 'Cámaras', maison: 'Hogar', autre: 'Otro',
  },
};

function detectLang() {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved && T[saved]) return saved;
  return 'en';
}

const LangContext = createContext({ lang: 'fr', t: T.fr, setLang: () => {}, dir: 'ltr' });

export function LangProvider({ children }) {
  const [lang] = useState(detectLang);

  const setLang = (code) => {
    localStorage.setItem(STORAGE_KEY, code);
    window.location.reload();
  };

  const langMeta = LANGUAGES.find(l => l.code === lang) || LANGUAGES[0];

  useEffect(() => {
    document.documentElement.dir = langMeta.dir;
    document.documentElement.lang = lang;
  }, [lang, langMeta.dir]);

  return (
    <LangContext.Provider value={{ lang, t: T[lang] || T.fr, setLang, dir: langMeta.dir }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() { return useContext(LangContext); }
